import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_b32f512a";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_b32f512a" };
/** script content **/
require("./button-group.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findexb32f512a%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fbutton-group%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_b32f512a"],
    ctorType: "component",
    outputPath: "components/indexb32f512a/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
